import { sInputKeyValidationHelper, sIsValidPostcode, sGetFromEngagementTools } from "../../shared.min.js";

const houseBuildDate = (() => {
	const endpoint = document.getElementById('endpoints');
	const apiKey = endpoint.dataset.apikey;
	//LIVE URLS
	const addressLookupURL = endpoint.dataset.address;
	const propertyLookupURL = endpoint.dataset.property;
	//TESTING URLS
	// const addressLookupURL = 'http://localhost:3000/address-lookup?postcode=';
	// const propertyLookupURL = 'http://localhost:3000/property-lookup?udprn=';
	const banner = document.querySelector('.banner');
	const progressBar = banner.querySelector('.banner__progress-bar span');
	const progressTitle = banner.querySelector('.banner__title');
	const progressStep = banner.querySelector('.banner__progress-step-value');
	const inputPostcodeSection = document.getElementById('input-postcode');
	const findPropertyButton = inputPostcodeSection.querySelector('#submit-postcode');
	const postcode = document.getElementById('hbPostcode');
	const postcodeSubmit = document.getElementById('submit-postcode');
	const addressSelect = document.getElementById('address-select');
	const houseDetailsSection = document.getElementById('house-details');
	const changePostcode = document.getElementById('changePostcode');
	const submitAddress = document.getElementById('submit-address');
	const displayResult = document.getElementById('house-results');
	const noResults = document.getElementById('no-results');
	const apiError = document.getElementById('api-error');
	const backToStart = document.querySelectorAll('.back-to-start');
	let isValid;

	const getAddressData = async (addressLookupURL, addressSelect) => {
		try {
			const response = await sGetFromEngagementTools(apiKey, addressLookupURL);

			if (!response.ok) {
				handleApiErrorStates(response, inputPostcodeSection);
			} else {
				const addressLookupData = await response.json();

				if (addressLookupData === null || addressLookupData.length === 0) {
					const fieldGroup = inputPostcodeSection.querySelector('.field-group');
					const errorMessage = fieldGroup.querySelector('.error-message');
					const errorMessageText = fieldset.querySelector('.address-not-found-error').textContent || "Address could not be found.";
					
					errorMessage.textContent = errorMessageText;
					fieldGroup.classList.add('field-group--error');
				} else {
					populateAddress(addressSelect, addressLookupData);
				}
			}

			submitButtonState(findPropertyButton, false);
		} catch (error) {
			apiError.classList.remove('display-none');
			inputPostcodeSection.classList.add('display-none');
			progressTitle.textContent = apiError.getAttribute('data-title');
			console.error(error);
			return;
		}
	};

	const getPropertyData = async propertyLookupURL => {
		try {
			const response = await sGetFromEngagementTools(apiKey, propertyLookupURL);

			if (!response.ok) {
				handleApiErrorStates(response, displayResult);
			} else {
				const propertyLookupData = await response.json();

				if (propertyLookupData !== null) {
					const actualDate = propertyLookupData.yearBuilt.value;
					const houseResults = document.querySelectorAll('.house-result');

					for (let i = 0; i < houseResults.length; i++) {
						if (actualDate >= houseResults[i].dataset.from && actualDate <= houseResults[i].dataset.to) {
							const dateBuilt = houseResults[i].querySelector('.dateBuilt');
							houseResults[i].classList.remove('display-none');
							dateBuilt.textContent = `${actualDate}*`;
						}
					}
				}
			}

			submitButtonState(submitAddress, false);
		} catch (error) {
			const allSections = document.querySelectorAll('#cnfsd-pc-built .house-build-date__section');
			allSections.forEach(section => {
				section.classList.add('display-none');
			});
			apiError.classList.remove('display-none');
			progressTitle.textContent = apiError.getAttribute('data-title');
			console.error(error);
		}
	};

	const handleApiErrorStates = (response, section) => {
		let errorMessage = '';
		switch (response.status) {
			case 400:
				errorMessage = 'Bad Request: The server could not understand the request due to invalid syntax.';
				throw new Error(errorMessage);
			case 401:
				errorMessage = 'Unauthorized: Access is denied due to invalid credentials.';
				throw new Error(errorMessage);
			case 403:
				errorMessage = 'Forbidden: You do not have the necessary permissions to access this resource.';
				throw new Error(errorMessage);
			case 500:
				errorMessage =
					"Internal Server Error: The server has encountered a situation it doesn't know how to handle.";
				throw new Error(errorMessage);
			case 404:
			default:
				noResults.classList.remove('display-none');
				section.classList.add('display-none');
				progressTitle.textContent = noResults.getAttribute('data-title');
		}
		return errorMessage;
	};

	const getAddresses = (postcode, addressSelect) => {
		const addressLookupURLpostcode = `${addressLookupURL}${postcode.value}`;
		getAddressData(addressLookupURLpostcode, addressSelect);
	};

	const populateAddress = (addressSelect, postcodeData) => {
		postcodeData.forEach(option => {
			const opt = document.createElement('option');
			opt.value = option.udprn;
			opt.textContent = option.preview;
			addressSelect.appendChild(opt);
			addressSelect.selectedIndex = 0;
		});

		progressStep.textContent = 2;
		progressBar.classList = '';
		progressBar.classList.add('progress-2');
		progressTitle.textContent = houseDetailsSection.getAttribute('data-title');

		inputPostcodeSection.classList.add('display-none');
		houseDetailsSection.classList.remove('display-none');

		const pcResult = document.getElementById('pc-result');
		pcResult.textContent = postcode.value;

		submitButtonState(findPropertyButton, false);
	};

	const reset = (postcode, displayResult, step, addressSelect) => {
		progressStep.textContent = 1;
		progressBar.classList = '';
		progressBar.classList.add('progress-1');
		progressTitle.textContent = inputPostcodeSection.getAttribute('data-title');
		noResults.classList.add('display-none');
		apiError.classList.add('display-none');
		submitButtonState(findPropertyButton, false);

		if (step === '2') {
			houseDetailsSection.classList.add('display-none');
		} else if (step === '3') {
			displayResult.classList.add('display-none');
		}

		while (addressSelect.options.length > 1) {
			addressSelect.remove(1);
		}

		const houseResults = document.querySelectorAll('.house-result');

		for (let i = 0; i < houseResults.length; i++) {
			if (!houseResults[i].classList.contains('display-none')) {
				houseResults[i].classList.add('display-none');
			}
		}

		inputPostcodeSection.classList.remove('display-none');
		postcode.value = '';
	};

	const displayProperty = (displayResult, selectedValue) => {
		const propertyLookupURLudprn = `${propertyLookupURL}${selectedValue}`;

		getPropertyData(propertyLookupURLudprn);
		progressStep.textContent = 3;
		progressBar.classList = '';
		progressBar.classList.add('progress-3');
		progressTitle.textContent = displayResult.getAttribute('data-title');
		displayResult.classList.remove('display-none');
		houseDetailsSection.classList.add('display-none');
	};

	const formValidation = (elem, type) => {
		const valTarget = document.querySelector(elem);
		const fieldset = valTarget.closest('.field-group');
		fieldset.classList.remove('field-group--error');

		const errorMessages = {
			empty: document.querySelector('.keypress-val-error').textContent,
			tooShort: document.querySelector('.keypress-val-error').textContent,
			tooLong: document.querySelector('.keypress-val-error').textContent,
			invalidFormat: document.querySelector('.address-not-found-error').textContent
		}

		let errorMessage = '';

		switch (type) {
			case 'postcode':
				({ isValid, errorMessage } = sIsValidPostcode(valTarget.value, errorMessages));
				break;

			case 'isSelected':
				valTarget.value === '' || valTarget.value === null ? (isValid = false) : (isValid = true);
				break;

			default:
				alert('Unknown validation type');
		}

		if (isValid) {
			fieldset.classList.remove('field-group--error');
		} else {
            if (errorMessage) fieldset.querySelector('.error-message').textContent = errorMessage;
			fieldset.classList.add('field-group--error');
		}
		return isValid;
	};

	const submitButtonState = (button, disabled) => {
		if (button.getAttribute('data-originaltext') === '' || button.getAttribute('data-originaltext') === null) {
			const innerButtonText = button.textContent;
			button.setAttribute('data-originaltext', innerButtonText);
		}

		if (disabled === true) {
			button.classList.add('btn--loading');
			button.setAttribute('aria-disabled', true);
			button.setAttribute('disabled', true);
			button.textContent = 'loading';
		} else {
			button.classList.remove('btn--loading');
			button.removeAttribute('aria-disabled');
			button.removeAttribute('disabled');
			button.textContent = button.getAttribute('data-originaltext');
		}
	};

	const setupKeyListener = () => {
		const fieldGroup = postcode.closest('.field-group');
		sInputKeyValidationHelper(postcode, "alphaNumeric", fieldGroup);
	};

	const init = () => {
		setupKeyListener()

		postcodeSubmit.addEventListener('click', event => {
			event.preventDefault();
			submitButtonState(findPropertyButton, true);

			formValidation('#hbPostcode', 'postcode');

			if (isValid) {
				getAddresses(postcode, addressSelect);
			} else {
				submitButtonState(findPropertyButton, false);
			}
		});

		changePostcode.addEventListener('click', event => {
			event.preventDefault();
			const step = changePostcode.getAttribute('data-step');
			reset(postcode, displayResult, step, addressSelect);
		});

		backToStart.forEach(btn => {
			btn.addEventListener('click', event => {
				const step = btn.getAttribute('data-step');
				event.preventDefault();
				reset(postcode, displayResult, step, addressSelect);
				banner.scrollIntoView({ behavior: 'smooth' });
			});
		});

		submitAddress.addEventListener('click', event => {
			event.preventDefault();
			formValidation('#address-select', 'isSelected');

			if (isValid) {
				submitButtonState(submitAddress, true);
				const selectedValue = addressSelect.value;
				displayProperty(displayResult, selectedValue);
			}

			submitButtonState(submitAddress, false);
		});

		addressSelect.addEventListener('change', () => {
			formValidation('#address-select', 'isSelected');
		});
	};

	return {
		init: init,
	};
})();
document.addEventListener('DOMContentLoaded', () => {
	houseBuildDate.init();
});
